import MoveManger from "../../../../gd/manager/move-manager"
import ProjectSession from "../../../../model2/project/project-session"

type ModalMoveTo_commitParams = {
    projectToMove   : ProjectSession
    targetProject   : ProjectSession
}

export default function ModalMoveTo_commitProjectMoveToFolder(params: ModalMoveTo_commitParams, onMoveCallback?: {(selectedProjectId?: ID): void} ) {
    MoveManger.moveProjectToProject(params.projectToMove.id, params.targetProject?.id, () => {
        onMoveCallback?.()
        gd.modal.hide()
    })
}